import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDemoData } from "@/hooks/useDemoData";
import { Rocket, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function DemoDataBanner() {
  const { t } = useTranslation();
  const { isDemoMode, isClearing, clearDemoData } = useDemoData();
  const [showConfirm, setShowConfirm] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!isDemoMode || dismissed) return null;

  return (
    <>
      <div className="mb-4 flex items-center justify-between gap-3 rounded-xl border border-primary/20 bg-primary/5 px-4 py-3 text-sm animate-fade-in">
        <div className="flex items-center gap-2 text-foreground">
          <Rocket className="h-4 w-4 text-primary shrink-0" />
          <span>{t('demo.bannerMessage')}</span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            size="sm"
            onClick={() => setShowConfirm(true)}
            disabled={isClearing}
            className="h-7 text-xs"
          >
            {isClearing ? t('loading', 'Loading...') : t('demo.goLive')}
          </Button>
          <button
            onClick={() => setDismissed(true)}
            className="text-muted-foreground hover:text-foreground transition-colors"
            aria-label={t('close', 'Close')}
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>

      <AlertDialog open={showConfirm} onOpenChange={setShowConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{t('demo.confirmTitle')}</AlertDialogTitle>
            <AlertDialogDescription>
              {t('demo.confirmDescription')}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>{t('cancel', 'Cancel')}</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                setShowConfirm(false);
                clearDemoData();
              }}
            >
              {t('demo.confirmAction')}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
